import { UserRoleActionsMenu } from '@modules/users/components/UsersTable/UserRoleActionsMenu';
import { UserRow, UserRowRoleType } from '@modules/users/store/types';
import { Box, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

export const renderUserRoleRowCell = (
  params: GridRenderCellParams<UserRow, UserRowRoleType, unknown>,
) => {
  const role = params.value;

  const getTextColor = () => {
    if (role === UserRowRoleType.Suspended) {
      return 'text.secondary';
    }
    if (role === UserRowRoleType.Admin) {
      return 'info.light';
    }
    return 'text.primary';
  };

  return (
    <Box>
      <Typography variant="body2" color={getTextColor()}>
        {role}
      </Typography>
      <UserRoleActionsMenu params={params} />
    </Box>
  );
};
